import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { PublicMenuView } from "./AllergenMenu";
import { Loader2, AlertTriangle } from "lucide-react";

export default function AllergenPreview() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/allergen-qr/${id}/preview`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e?.normalized?.message || "Preview unavailable"));
  }, [id]);

  if (error) return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6 text-center">
      <AlertTriangle className="text-amber-500" size={30} />
      <p className="mt-3 text-slate-600">{error}</p>
    </div>
  );
  if (!data) return <div className="min-h-screen bg-slate-50 flex items-center justify-center"><Loader2 className="animate-spin text-brand" /></div>;

  return (
    <div data-testid="allergen-preview">
      <div className="bg-slate-800 text-white text-center text-xs py-1.5">Manager preview — this is what customers see</div>
      <PublicMenuView data={data} />
    </div>
  );
}
